import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Content from "../components/SubPages/Content"
import Map from "../components/SubPages/Map"
import Gallery from "../components/SubPages/Gallery"
import { useLanguage } from '../context/LanugageContext'
import { subpagesTranslations } from '../translations/subpages'

import dubrovnikMap from "../images/Dubrovnik-nove/karta.jpg"
import openMap from "../images/Dubrovnik-nove/karta.jpg"
import plakatDubrovnik from "../images/Dubrovnik-nove/dubrovnik-plakat.jpg"

import elaphiteMap from "../images/Elafiti-nove/karta2.jpg"
import elaphitiopenMap from "../images/Elafiti-nove/karta-mala.png"
import epalhitiPlakat from "../images/Elafiti-nove/elafiti-plakat.jpg"

import img1 from "../images/Dubrovnik-nove/1.jpg"
import img2 from "../images/Dubrovnik-nove/2.jpg"
import img3 from "../images/Dubrovnik-nove/dubrovnik3.jpg"
import img4 from "../images/Dubrovnik-nove/4.jpg"
//import img5 from "../images/Dubrovnik-nove/5.jpg"
//import imgDub6 from "../images/Dubrovnik-nove/6.jpg"
import imgDub7 from "../images/Dubrovnik/croatia-3605569_640.jpg"
import imgDub8 from "../images/Dubrovnik/dubrovnik-4708784_640.jpg"

import img6 from "../images/Elafiti-nove/1.jpg"
import img7 from "../images/Elafiti-nove/elafiti-26.jpg"
import img8 from "../images/Elafiti-nove/3.jpg"
import img10 from "../images/Elafiti/lopud-1.jpg"
import img11 from "../images/Elafiti/LOPUD-Sunj-D85_5178-Pano_ACR-aleksandar-gospic.jpg"
import img15 from "../images/Elafiti/P7070468.JPG"
import img16 from "../images/Elafiti/P7120425.JPG"
import img17 from "../images/Elafiti/1280951147.jpg"
import img18 from "../images/Elafiti/20664751_347332562356035_4285216456550861844_n.jpg"

const subpagesMeta = [
    {
        name: "dubrovnik",
        link: "http://www.tzdubrovnik.hr/lang/en/index.html",
        startTime: "09:00",
        pickUpTime: "09:10",
        heroClass: "hero-single dubrovnik",
        class: "dubrovnik",
        plakat: plakatDubrovnik,
        widgetId: "a147a76f-4c2b-4216-bee5-277d141b009e",
        map: {
            map: dubrovnikMap,
            smallMap: openMap,
            openMap: openMap,
            alt: "map-dubrovnik"
        },
        gallery: [
            { img: img1 },
            { img: img2 },
            { img: img3 },
            { img: img4 },
           /*  { img: img5 }, */
            /* { img: imgDub6 }, */
            { img: imgDub7 },
            { img: imgDub8 }
        ]
    },
    {
        name: "elaphiti",
        link: "http://www.tzdubrovnik.hr/lang/en/get/okolica_dubrovnika/62179/otok_lopud.html",
        secondLink: "http://www.tzdubrovnik.hr/lang/en/get/okolica_dubrovnika/62186/otok_sipan.html",
        startTime: "09:00",
        pickUpTime: "09:10",
        heroClass: "hero-single elaphiti",
        class: "elaphiti",
        plakat: epalhitiPlakat,
        widgetId: "5dd86369-993b-428e-b4d8-56e8dcd68dca",  
        map: {
            map: elaphiteMap,
            smallMap: elaphitiopenMap,
            openMap: elaphitiopenMap,
            alt: "map-elaphiti"
        },
        gallery: [
            { img: img6 },
            { img: img7 },
            { img: img8 },
            { img: img10 },
            { img: img11 },
            { img: img15 },
            { img: img16 },
            { img: img17 },
            { img: img18 }
        ]
    }
]

const SubPages = () => {
    const { subpageParam } = useParams();
    const { lang } = useLanguage();

    const meta = subpagesMeta.find(s => s.name === subpageParam);
    const translations = subpagesTranslations[lang]?.[subpageParam];

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [subpageParam])

    if (!meta || !translations) return <div>Not found: {subpageParam}</div>

    const regiondoLang = {
        en: 'en',
        hr: 'hr',
        es: 'es',
        it: 'it',
        pl: 'pl',
        fr: 'fr',
        de: 'de'
    }

    const bookingWidget = (
        <booking-widget
            widget-id={meta.widgetId}
        />
    )

    const content = {
        ...translations,
        link: meta.link,
        secondLink: meta.secondLink,
        startTime: meta.startTime,
        pickUpTime: meta.pickUpTime,
        heroClass: meta.heroClass,
        class: meta.class,
        plakat: meta.plakat,
        bookingWidget: bookingWidget,
    }

    return (
        <div>
            <Content content={content} />
            <Map map={meta.map} />
            <Gallery gallery={meta.gallery} />
        </div>
    )
}

export default SubPages